
export class SmsLogModel {
    
    id: number;
    userName: string;
    entityType: string;
    entityId: number;
    createDate: Date;
    createById: number;
    createUserName: string;
    updateById: number;
    updatedDate: Date;
    sendNumber: string;
    receiveNumber: string;
    resultNo: string;
    resultText: string;
    isActive: boolean;
    isSent: boolean;
    sendDate: Date | null;
    messageTxt: string;

    constructor(
        id: number,
        userName: string,
        entityType: string,
        entityId: number,
        createDate: Date,
        createById: number,
        createUserName: string,
        updateById: number,
        updatedDate: Date,
        sendNumber: string,
        receiveNumber: string,
        resultNo: string,
        resultText: string,
        isActive: boolean,
        isSent: boolean,
        sendDate: Date | null,
        messageTxt: string,
    ) {
        this.id = id;
        this.userName = userName;
        this.createById = createById;
        this.createUserName =createUserName;
        this.entityType = entityType;
        this.entityId = entityId;
        this.createDate = createDate;
        this.updateById = updateById;
        this.updatedDate = updatedDate;
        this.sendNumber = sendNumber;
        this.receiveNumber = receiveNumber;
        this.resultNo = resultNo;
        this.resultText = resultText;
        this.isActive = isActive;
        this.isSent = isSent;
        this.sendDate = sendDate;
        this.messageTxt = messageTxt;
    }

    public static fromJson(json: any): SmsLogModel {
        return new SmsLogModel(
            json["id"],
            json["userName"],
            json["entityType"],
            json["entityId"],
            new Date(json["createDate"]),
            json["createById"],
            json["createUserName"],
            json["updateById"],
            new Date(json["updatedDate"]),
            json["sendNumber"],
            json["receiveNumber"],
            json["resultNo"],
            json["resultText"],
            json["isActive"],
            json["isSent"],
            json["sendDate"] ? new Date(json["seenDate"]) : null,
            json["messageTxt"],
        );
    }
}
export interface SmsLogGetPayloadFilterModel {
    Id?: number;
    UserId?: number;
    CreateById?: number;
    CreateDate?: Date|null;
    SendDate?: Date|null;
    UserName?: string;
    SendNumber?: string;
    ReceiveNumber?: string;
    MessageTxt?: string;
    EntityId?: number;
    EntityType?: string;
    ResultNo?: number;
    ResultText?: string;
    IsSent?: number;
}

export interface SmsLogGetPayloadModel {
    pageSize?: number;
    pageNumber?: number;
    Filters?: SmsLogGetPayloadFilterModel;
}


export interface SmsLogPayloadModel {
    Id?: number;
    EntityId?: number;
    EntityType: string;
    MessageTxt: string;
    ReceiveNumber: string;
    UserId: number;
    IsActive: boolean;
}
